import { Injectable } from '@angular/core';
import { _ } from '@biesbjerg/ngx-translate-extract/dist/utils/utils';
import { Util } from '../helpers/global.util';
import { BehaviorSubject } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class SidebarService {
   
    autoSlide = false;
    siteMap: any[] = [];
    menus = [];
    private toggledSource = new BehaviorSubject<boolean>(false);
    toggled$ = this.toggledSource.asObservable();
    constructor() {
        window.addEventListener('popstate', () => {
            console.log('go back/forward');

            this.getSiteMapByUrl();
        });
    }
    get toggled(): boolean {
        return this.toggledSource.value;
    }
    build(items: any) {
        this.menus = items;

        //called when refresh page such as press F5
        this.getSiteMapByUrl();
    }

    toggle() {
        this.toggledSource.next(!this.toggled);
       // this.toggled = !this.toggled;
    }

    setSidebarState(state: boolean) {
      //  this.toggled = state;
        this.toggledSource.next(!this.toggled);
    }

    invertSidebarState() {
        //this.toggled = !this.toggled;
        //this.autoSlide = this.toggled ? true : false;
       
        const newState = !this.toggled;
        this.toggledSource.next(newState);
        this.autoSlide = newState;
    }

    slide(state: boolean) {
        if (this.autoSlide)
            this.setSidebarState(state);
    }

    getSidebarState() {
        return this.toggled;
    }

    isTogged() {
        return this.toggled;
    }

    isAutoSlide() {
        return this.autoSlide;
    }

    getMenuList() {
        return this.menus;
    }

    getSiteMap(currentMenu: any) {
        this.siteMap = [];
        this.findSiteMap(currentMenu, this.menus);
    }

    findSiteMap(currentMenu: any, menus: any): boolean {
        for (let i = 0; i < menus.length; i++) {
            let p = menus[i];

            if (p === currentMenu) {
                this.siteMap.push({ 'Title': p.title, 'Link': p.link });
                return true;
            }

            if (p.type === 'dropdown') {
                this.siteMap = [];
                this.siteMap.push({ 'Title': p.title, 'Link': p.link });

                if (this.findSiteMap(currentMenu, p.submenus))
                    return true;

                this.siteMap = [];
            }
        }

        return false;
    }

    getSiteMapByUrlNew(userType: string) {
        let url = window.location.href;
        let path = Util.getPathWithoutParam(url);
        console.log(path);

        this.reset();
        this.findSiteMapByUrl(path, this.menus);

        //if not found then find by path code
        if (this.siteMap.length == 0) {            
            let code = Util.getPathCode(url);
            this.findSiteMapByPathCodeNew(path, code, userType);
        }
    }

    getSiteMapByUrl() {
        let url = window.location.href;
        let path = Util.getPathWithoutParam(url);
        console.log(path);

        this.reset();
        this.findSiteMapByUrl(path, this.menus);

        //if not found then find by path code
        if (this.siteMap.length == 0) {
            let code = Util.getPathCode(url);
            this.findSiteMapByPathCode(path, code);
        }
    }

    findSiteMapByUrl(path: string, menus: any): boolean {
        for (let i = 0; i < menus.length; i++) {
            let p = menus[i];

            if (p.link === path) {
                this.siteMap.push({ 'Title': p.title, 'Link': p.link });
                return true;
            }

            if (p.type === 'dropdown') {
                this.siteMap = [];
                this.siteMap.push({ 'Title': p.title, 'Link': p.link });

                if (this.findSiteMapByUrl(path, p.submenus))
                    return true;

                this.siteMap = [];
            }
        }

        return false;
    }

    findSiteMapByPathCode(path: string, code: number) {        
        if (path === '/request-prop') {
            let p = this.findDropDownMenu('Hospital support', this.menus);            
            if (p != null && p.submenus != null) {
                /*
                if (0 <= code && code < p.submenus.length) {
                    let q = p.submenus[code];
                    this.addPath(p.title);
                    this.addPath(q.title, q.link);
                }*/

                for (let i = 0; i < p.submenus.length; i++) {
                    let q = p.submenus[i];
                    if (q.pathCode == code) {
                        this.addPath(p.title);
                        this.addPath(q.title, q.link);
                        break;
                    }
                }
            }
        }
    }

    findSiteMapByPathCodeNew(path: string, code: number, userType: string) {
        if (path === '/request-prop') {
            let strParentMenu = 'Hospital support';
            if (userType == 'FFM') {
                strParentMenu = 'Field force manager'
            } else if (userType == 'SC') {
                strParentMenu = 'Sales consultant'
            }
            let p = this.findDropDownMenu(strParentMenu, this.menus);
            if (p != null && p.submenus != null) {
                /*
                if (0 <= code && code < p.submenus.length) {
                    let q = p.submenus[code];
                    this.addPath(p.title);
                    this.addPath(q.title, q.link);
                }*/

                for (let i = 0; i < p.submenus.length; i++) {
                    let q = p.submenus[i];
                    if (q.pathCode == code) {
                        this.addPath(p.title);
                        this.addPath(q.title, q.link);
                        break;
                    }
                }
            }
        }
    }

    findDropDownMenu(title: string, menus: any) {
        for (let i = 0; i < menus.length; i++) {
            let p = menus[i];

            if (p.title === title) {
                return p;
            }

            if (p.type === 'dropdown') {
                let q = this.findDropDownMenu(title, p.submenus);
                if (q != null)
                    return q;
            }
        }

        return null;
    }

    reset() {
        this.siteMap = [];
    }

    addPath(name: string, link?) {
        if (link === undefined)
            this.siteMap.push({ 'Title': name, 'Link': "" });
        else
            this.siteMap.push({ 'Title': name, 'Link': link });
    }
}
